import {
  FUNDING_MAP_CATEGORIES,
  FUNDING_MAP_DEFAULT_CHAIN_ID,
  FUNDING_MAP_ECOSYSTEMS,
  FUNDING_MAP_GRANT_TYPES,
  FUNDING_MAP_NETWORKS,
  FUNDING_MAP_STATUSES,
  NETWORK_IMAGES,
} from "@/src/features/funding-map/constants/filter-options";

const organizations = [
  "3327",
  "01 Exchange",
  "0x Protocol",
  "1inch Foundation",
  "4EVERLAND",
  "88mph",
  "Aave",
  "Aavegotchi",
  "Abracadabra.money",
  "Acala",
  "ACryptoS",
  "AirCoin",
  "Ajna",
  "Akash",
  "Alchemix",
  "Alchemy",
  "Aleo",
  "Aleph Zero",
  "Algofi",
  "Algorand Foundation",
  "Algovera",
  "Alien Worlds",
  "Allbridge",
  "Alpaca Finance",
  "Alpha Venture DAO",
  "Ampleforth",
  "AngelBlock",
  "Ankr",
  "ApeCoin DAO",
  "ApeSwap",
  "Aptos Foundation",
  "Aragon",
  "Arbitrum Foundation",
  "Arcana",
  "Archway",
  "ARKEN Finance",
  "Arweave",
  "AssetMantle",
  "Astar",
  "ATOM Accelerator",
  "Audius",
  "Aura Finance",
  "Aurora",
  "Avalanche",
  "Axelar",
  "Axie Infinity",
  "Aztec",
  "BabySwap",
  "Badger DAO",
  "Balancer",
  "BanklessDAO",
  "BarnBridge",
  "Base",
  "Bastion",
  "Beefy Finance",
  "Beethoven X",
  "Belt Finance",
  "Benqi",
  "Berachain",
  "Biconomy",
  "BiFi",
  "Biswap",
  "bitfari",
  "BNB Chain",
  "Boba Network",
  "Bogged Finance",
  "BONKz",
  "Bountycaster",
  "Braintrust Grants",
  "Callisto Network",
  "Canto",
  "Casper",
  "Celer Network",
  "Celo",
  "Ceramic Network",
  "Chainlink",
  "Chromia",
  "Circle",
  "CityDAO",
  "Climate Collective",
  "Clipper DEX",
  "Clover Finance",
  "clr.fund",
  "Coinbase",
  "CoinEx Smart Chain",
  "Combo",
  "Composable",
  "Compound",
  "Conflux",
  "Connext",
  "Consensys",
  "Convex Finance",
  "Coreum",
  "Cosmos Community Grants",
  "Covalent",
  "CoW Protocol",
  "Creatives DAO (NEAR)",
  "Cronos",
  "Crust Network",
  "Cube Network (Huobi)",
  "Cudos Foundation",
  "Cult DAO",
  "Curve",
  "Cypherpunk Guild (NEAR)",
  "DAOHaus",
  "DAOSquare",
  "Dark Forest",
  "Darwinia Grants",
  "Dash",
  "Decentraland",
  "Decred",
  "Defibox",
  "Dfinity (ICP)",
  "dForce",
  "Diamond DAO",
  "DIMO",
  "DODO",
  "Dopex Diamond Grants",
  "Dora Factory",
  "Dune Analytics",
  "dYdX",
  "eco",
  "Edgeware",
  "ElementFi",
  "Enjin",
  "ENS",
  "EOS",
  "Ergo",
  "ETH Prize",
  "Ethereum Foundation",
  "Euler Finance",
  "Everscale",
  "Evmos",
  "Fantom Foundation",
  "Filecoin Foundation",
  "Findora",
  "Flare",
  "Flow",
  "Flux Labs",
  "Forta",
  "Frax Finance",
  "Fuel",
  "Fuse",
  "Fusion",
  "Gains Network",
  "Game7",
  "Gari Developer DAO",
  "Gearbox",
  "Geyser",
  "Gitcoin",
  "Giveth",
  "GMX",
  "Gnosis DAO",
  "Golem Foundation",
  "Grant for the Web(Interledger)",
  "Grantshares",
  "Graph",
  "Harmony",
  "Harvest Finance",
  "Hashgraph",
  "Hedera",
  "Helium",
  "HOP Protocol",
  "HOPR",
  "Horizen",
  "Human Guild (NEAR)",
  "HUMANODE",
  "Huobi",
  "Hxro",
  "HydraDX",
  "Icon",
  "Idle DAO",
  "Illuvium",
  "Immutable X",
  "Index Coop",
  "Injective",
  "Inkubator",
  "Instadapp Lite",
  "Interchain Foundation",
  "Interlay",
  "IoTeX",
  "Juno",
  "JustLend",
  "Kadena",
  "Kava",
  "Klaytn Foundation",
  "KlimaDAO",
  "KORIS",
  "Kraken",
  "KuCoin Community Chain",
  "Kujira",
  "Kyber Network",
  "LayerZero",
  "Lens Protocol",
  "Lido (LEGO)",
  "LiquidApps",
  "Liquity",
  "Lisk",
  "Lit Protocol",
  "Livepeer",
  "LooksRare",
  "Loopring",
  "Lyra",
  "MakerDAO",
  "Mantle",
  "MAP Protocol",
  "Marinade Finance",
  "MatchboxDAO",
  "MetaCartel",
  "MetaGammaDelta",
  "Metamask Grants DAO",
  "Meter",
  "Metis",
  "MetricsDAO",
  "Metropolis (Orca)",
  "Milkomedia",
  "MilkRoad",
  "Mina Foundation",
  "Mint Fund",
  "MintBase (NEAR)",
  "Mirror Club (mClub)",
  "MolochDAO",
  "MonkeDAO",
  "Moonbeam",
  "Moonwell",
  "mStable",
  "Music Fund",
  "Near Foundation",
  "NEO",
  "Neon Foundation",
  "Nervos Network",
  "Neutron",
  "Nexus Mutual",
  "Notional",
  "Nouns DAO",
  "OAK Network",
  "Oasis Network",
  "OAX",
  "Obyte",
  "Ocean Protocol",
  "OKC",
  "Olympus",
  "Ontology",
  "OpenGrants (Ethereum)",
  "OpenLeverage",
  "OpenSea",
  "Optimism Foundation",
  "Orange DAO",
  "Origami",
  "Osmosis",
  "Paladin",
  "PancakeSwap",
  "Parity Technologies",
  "PBS Foundation Grants",
  "peaq",
  "Perpetual Protocol",
  "PIVX",
  "pNetwork",
  "Pollen",
  "Polygon Labs",
  "Polymesh",
  "PoolTogether",
  "PowerPool",
  "Prisma Finance",
  "Project Catalyst,Cardano Foundation",
  "Protocol Labs",
  "Provenance",
  "Proximity Labs (NEAR)",
  "PSE (Privacy and Scaling Explorations)",
  "Push Protocol",
  "Questbook",
  "QuickSwap",
  "Radicle",
  "Radix",
  "Raft",
  "Rally",
  "Rarible",
  "Ravencoin",
  "Redbelly",
  "Reflexer Labs",
  "REI Network",
  "Request Network",
  "Reserve",
  "Ripple",
  "RocketPool",
  "Ronin",
  "Rook",
  "Rootstock",
  "Safe",
  "Sandbox",
  "Scallop",
  "Seahorse Lang",
  "Secret Network",
  "Seed Club",
  "Sei",
  "Sevens Foundation",
  "SKALE",
  "Social Alpha Foundation",
  "Solana Foundation",
  "Sovryn",
  "SpaceID",
  "Spiral",
  "SpookySwap",
  "Stacks Foundation",
  "StarCoin",
  "Starknet",
  "Stellar Development Foundation",
  "Streamr Network",
  "Strike Finance",
  "Sui Foundation",
  "Superfluid",
  "SuperRare",
  "Superteam",
  "SushiSwap",
  "Swarm Foundation",
  "Synapse",
  "Synthetix",
  "Syscoin",
  "Tableland",
  "Taiko",
  "Tally",
  "Tea Protocol",
  "TegroFi",
  "Telos",
  "Tempus",
  "Tezos Foundation",
  "The LAO",
  "Thundercore",
  "Token Engineering Commons",
  "Tokenlon",
  "TON",
  "Toucan",
  "Tron",
  "Tulip",
  "Ubiquity DAO",
  "UMA",
  "Uniswap Foundation",
  "Unlock Protocol",
  "Unstoppable Domains",
  "Valist",
  "Vechain",
  "veFunder (Curve)",
  "Vega",
  "Velas",
  "Venus",
  "Vulcan Forged",
  "Waves",
  "Web3 Foundation",
  "WhiteBIT",
  "Worldcoin Foundation",
  "Wormhole xGrants",
  "XMTP",
  "XPR Network",
  "XRPL Grants",
  "yearn.finance",
  "zCash",
  "Zebec Protocol",
  "ZetaChain",
  "Zilliqa",
];

const platformsUsed = ["Gitcoin", "Questbook", "Charmverse", "GitHub", "Notion", "Custom"];

const grantSizes = [0, 250000];

export const registryHelper = {
  networks: [...FUNDING_MAP_NETWORKS],
  organizations,
  ecosystems: [...FUNDING_MAP_ECOSYSTEMS],
  categories: [...FUNDING_MAP_CATEGORIES],
  grantTypes: [...FUNDING_MAP_GRANT_TYPES],
  grantSizes,
  networkImages: NETWORK_IMAGES,
  platformsUsed,
  status: [...FUNDING_MAP_STATUSES],
  supportedNetworks: FUNDING_MAP_DEFAULT_CHAIN_ID,
};
